var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (this.objeto.acumulado)?_c('p',[_vm._v("Saldo acumulado: s/ "+_vm._s(_vm.arreglo_acumulado.reduce(function (a, b){ return a+b; }, 0)))]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }